module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    on: {
      "click": function($event) {
        return _vm.createNews()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Novo")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Notícias")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('DataTables', {
    attrs: {
      "tableId": "news-table",
      "url": this.apiUrl,
      "columns": this.columns,
      "columnDefs": this.columnDefs,
      "order": [
        [1, 'desc']
      ]
    }
  })], 1)]), _vm._v(" "), _c('notifier', {
    ref: "notifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-news-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Excluir Notícia")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("\n            Ao clicar em \"Ok\" a notícia será excluída do sistema.\n            Esta ação é irreversível! Deseja continuar?\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "delete-news-modal-confirm",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21077fcc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/news/NewsHome.vue
// module id = 698
// module chunks = 1